module.exports = __webpack_public_path__ + "static/user-testing@2x-02745d8a08822453f32f29348b696acb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/agencies-industry-pages/user-testing@2x.jpg
// module id = 2532
// module chunks = 281026976107462